module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_external_link_black-28c02a231d303936d33922629934c4f6.svg";